import { render } from "./BuildingAgeListing.vue?vue&type=template&id=7a046fad&ts=true"
import script from "./BuildingAgeListing.vue?vue&type=script&lang=ts"
export * from "./BuildingAgeListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__